import { ApiError } from "./api";

/** Infrastructure problems the UI explains in plain words (codes match the backend's service_errors). */
export type ServiceProblem =
  | "database_unavailable"
  | "database_access_denied"
  | "database_missing"
  | "schema_outdated"
  | "server_unreachable";

const BACKEND_CODES = new Set<string>([
  "database_unavailable",
  "database_access_denied",
  "database_missing",
  "schema_outdated",
]);

/** Problem reported by /api/health for the database, if any (unknown codes count as unreachable). */
export function healthProblem(
  database: { ok: boolean; problem?: string | null } | undefined,
): ServiceProblem | null {
  if (!database || database.ok) return null;
  return database.problem && BACKEND_CODES.has(database.problem)
    ? (database.problem as ServiceProblem)
    : "database_unavailable";
}

export function serviceProblem(error: unknown): ServiceProblem | null {
  if (error instanceof ApiError) {
    if (error.code && BACKEND_CODES.has(error.code)) return error.code as ServiceProblem;
    // A reverse proxy answering for a stopped application, or the server itself overloaded.
    if (error.status === 502 || error.status === 503 || error.status === 504) return "server_unreachable";
    return null;
  }
  // fetch() rejects with a TypeError when the server cannot be reached at all.
  if (error instanceof TypeError) return "server_unreachable";
  return null;
}
